import React, { useState, useRef, useLayoutEffect, useEffect, useMemo, useCallback } from 'react';
import Select, { components } from 'components/common/AppSelect'
import LoadingFail from '../common/loading_fail_detail';
import { observer } from 'mobx-react'
import './index.css';
import GlobalState, {addModels, changemodelflag, changeActiveModel, changepopupaddAttachmentAnalitics, changeActiveModeldatasetPrew} from "../../stores/GlobalState";
import Pool from "../autorize/UserPool";
import Domen from "../../stores/Domen";
import lang from "../../lang";
import Loading from '../common/loading';

const OBS_MENU_SCROLL = { top: 0 };
const STEP = 0.05;

function roundToStep(value, step) {
  return Math.round(value / step) * step;
}

function sameStep(a, b, step = STEP) {
  // щоб не впіймати баги з float типу 0.1500000000002
  return Math.abs(roundToStep(a, step) - roundToStep(b, step)) < 1e-9;
}

function pad2(value) {
    return String(value).padStart(2, "0");
}

function normalizeDateLike(input) {
    if (input == null) {
        return {
            key: "",
            hasTime: false,
            display: "",
        };
    }

    const str = String(input).trim();
    if (!str) {
        return {
            key: "",
            hasTime: false,
            display: "",
        };
    }

    // unix timestamp: seconds or milliseconds
    if (/^\d{10,13}$/.test(str)) {
        const num = Number(str);
        const ms = str.length === 13 ? num : num * 1000;
        const d = new Date(ms);

        if (!Number.isNaN(d.getTime())) {
            const year = d.getFullYear();
            const month = pad2(d.getMonth() + 1);
            const day = pad2(d.getDate());
            const hh = pad2(d.getHours());
            const mm = pad2(d.getMinutes());
            const ss = pad2(d.getSeconds());

            const hasTime = hh !== "00" || mm !== "00" || ss !== "00";

            return {
                key: hasTime
                    ? `${year}-${month}-${day} ${hh}:${mm}:${ss}`
                    : `${year}-${month}-${day}`,
                hasTime,
                display: hasTime
                    ? `${day}.${month}.${year} ${hh}:${mm}:${ss}`
                    : `${day}.${month}.${year}`,
            };
        }
    }

    // YYYY-MM-DD or YYYY/MM/DD + optional time
    let m = str.match(
        /^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})(?:[T\s](\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?/
    );
    if (m) {
        const [, y, mo, d, h = "00", mi = "00", s = "00"] = m;

        const year = y;
        const month = pad2(mo);
        const day = pad2(d);
        const hh = pad2(h);
        const mm = pad2(mi);
        const ss = pad2(s);

        const hasTime = hh !== "00" || mm !== "00" || ss !== "00";

        return {
            key: hasTime
                ? `${year}-${month}-${day} ${hh}:${mm}:${ss}`
                : `${year}-${month}-${day}`,
            hasTime,
            display: hasTime
                ? `${day}.${month}.${year} ${hh}:${mm}:${ss}`
                : `${day}.${month}.${year}`,
        };
    }

    // DD.MM.YYYY / DD-MM-YYYY / DD/MM/YYYY + optional time
    m = str.match(
        /^(\d{1,2})[./-](\d{1,2})[./-](\d{4})(?:[T\s](\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?/
    );
    if (m) {
        const [, d, mo, y, h = "00", mi = "00", s = "00"] = m;

        const year = y;
        const month = pad2(mo);
        const day = pad2(d);
        const hh = pad2(h);
        const mm = pad2(mi);
        const ss = pad2(s);

        const hasTime = hh !== "00" || mm !== "00" || ss !== "00";

        return {
            key: hasTime
                ? `${year}-${month}-${day} ${hh}:${mm}:${ss}`
                : `${year}-${month}-${day}`,
            hasTime,
            display: hasTime
                ? `${day}.${month}.${year} ${hh}:${mm}:${ss}`
                : `${day}.${month}.${year}`,
        };
    }

    // fallback через Date()
    const parsed = new Date(str);
    if (!Number.isNaN(parsed.getTime())) {
        const year = parsed.getFullYear();
        const month = pad2(parsed.getMonth() + 1);
        const day = pad2(parsed.getDate());
        const hh = pad2(parsed.getHours());
        const mm = pad2(parsed.getMinutes());
        const ss = pad2(parsed.getSeconds());

        const hasTime = hh !== "00" || mm !== "00" || ss !== "00";

        return {
            key: hasTime
                ? `${year}-${month}-${day} ${hh}:${mm}:${ss}`
                : `${year}-${month}-${day}`,
            hasTime,
            display: hasTime
                ? `${day}.${month}.${year} ${hh}:${mm}:${ss}`
                : `${day}.${month}.${year}`,
        };
    }

    return {
        key: str,
        hasTime: false,
        display: str,
    };
}


const Addmodels = observer(({setAddmodel, openmodel}) => {
    
    const [obsLoading, setObsLoading] = useState(false);


    const [langmenu] = useState(localStorage.getItem("lang_site") || "en");
    const langv = useMemo(() => (langmenu === "de" ? lang.de : lang.en), [langmenu]);
    const [optionfields, setOptionfields] = useState([]);
    const [metadata, setMetadata] = useState([]);
    const [load, setLoad] = useState(0);
    const [namemodal, setNamemodal] = useState("");
    const [countmodal, setCountmodal] = useState("");
    const [optiontype, setOptiontype] = useState("");
    const [optionmetrics, setOptionmetrics] = useState("");
    const [optiontarget, setOptiontarget] = useState("");
    const [optiontargetfields, setOptiontargetfields] = useState("");
    const [disablebut, setDisablebut] = useState(true);
    const [isAdditionalTesting, setIsAdditionalTesting] = useState(false);
    const [newTabs, setNewTabs] = useState(0);

    const addNewTabs = () => {
        setNewTabs((prev) => prev + 1);
    };

    const menuListElRef = useRef(null);
    const menuScrollTopRef = useRef(0);
    const [obsMenuOpen, setObsMenuOpen] = useState(false);
    const [disabletitle, setDisabletitle] = useState(false)


    
    const options = useMemo(
        () => (GlobalState.dataset || []).map((n) => ({ value: n.id, label: n.name })),
        [GlobalState.dataset]
    );
    const optionstype = useMemo(
        () => [
            { value: "binary", label: "Binary" },
            { value: "multiclass", label: "Multiclass" },
            { value: "regression", label: "Regression" },
        ],
        []
    );
    const optionsstep = useMemo(
        () => [
            { value: "1", label: "1" },
            { value: "2", label: "2" },
            { value: "3", label: "3" },
            { value: "4", label: "4" },
            { value: "5", label: "5" },
            { value: "10", label: "10" },
            { value: "15", label: "15" },
            { value: "20", label: "20" },
        ],
        []
    )

    const Countamoda = useCallback((value) => {
        if (value === "") {
            setCountmodal("");
            return;
        }

        const numericValue = Number(value);
        if (Number.isFinite(numericValue) && numericValue > 0 && numericValue <= 20) {
            setCountmodal(value);
        }
    }, []);


    const [lower, setLower] = useState(0.5);
    const [upper, setUpper] = useState(0.5);
    // зберігаємо обраний об'єкт метрик (при коміті зі слайдера),
    // але як fallback також вираховуємо його через lower/upper
    const [selectedRow, setSelectedRow] = useState(null);

   

    const doubleThresholdsData =
        GlobalState.activemodel?.lastTrain?.metadata?.doubleThresholdsData || [];

    const selectedThresholdObj = useMemo(() => {
        return doubleThresholdsData.find(
        (o) =>
            sameStep(o.lowerThreshold, lower) &&
            sameStep(o.upperThreshold, upper)
        );
    }, [doubleThresholdsData, lower, upper]);
    
    // IMPORTANT: слайдер тепер "комітить" значення на release (onCommit),
    // щоб не навантажувати браузер перерендером на кожному кроці.
    const handleThresholdCommit = (newLower, newUpper, obj) => {
        setLower(newLower);
        setUpper(newUpper);
        setSelectedRow(obj || null);
    };

    // те, що реально прокидуємо в блоки: або те, що прийшло з commit,
    // або те, що знайшлося по lower/upper
    const thresholdDataResolved = selectedRow || selectedThresholdObj || null;

    // --- Additional testing period: observation dates multiselect ---
    const observationOptions = useMemo(() => {
    // приклад як на скрінах; можеш замінити на свої дані з API/GlobalState
    return [
        { value: "10.03.2025", label: "10.03.2025 (10%)", pct: 10 },
        { value: "12.03.2025", label: "12.03.2025 (20%)", pct: 20 },
        { value: "20.03.2025", label: "20.03.2025 (30%)", pct: 30 },
        { value: "01.04.2025", label: "01.04.2025 (10%)", pct: 10 },
        { value: "10.04.2025", label: "10.04.2025 (10%)", pct: 10 },
        { value: "20.04.2025", label: "20.04.2025 (20%)", pct: 20 },
    ];
    }, []);

    const [observationSelected, setObservationSelected] = useState([]);
    const [observationError, setObservationError] = useState(false);

    const observationTotal = useMemo(() => {
    return (observationSelected || []).reduce((sum, o) => sum + (o.pct || 0), 0);
    }, [observationSelected]);
    const isObservationOverLimit = isAdditionalTesting && observationTotal > 30;
    useLayoutEffect(() => {
        if (obsMenuOpen && menuListElRef.current) {
            // повертаємо скрол після перерендеру
            menuListElRef.current.scrollTop = menuScrollTopRef.current || 0;
        }
    }, [observationSelected, obsMenuOpen]);

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: 'rgba(255, 255, 255, 1)',
            display: 'flex',
            flexWrap: 'nowrap',
            width: 'calc(100% - 20px)',
            height: '38px',
            color: 'rgba(2, 2, 3, 1)',
            border: '1px solid rgba(255, 255, 255, 1)',
            boxShadow: 'none',
            fontSize: 16,
            '&:hover': {
                border: '1px solid rgba(245, 197, 56, 1)',
            },
        }),
        input: (provided) => ({
            ...provided,
            color: 'rgba(2, 2, 3, 1)',
        }),
        
        menu: (provided) => ({
            ...provided,
            background: 'rgba(255, 255, 255, 1)',
            width: 'calc(100% - 20px)',
            marginTop: '0px',
            boxShadow: 'none',
            cursor: 'pointer',
            color: 'rgba(2, 2, 3, 0.6)',
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: 16,
            paddingLeft: 0,
            color: state.isSelected ? 'rgba(235, 115, 27, 1)' : 'rgba(2, 2, 3, 1)',
            backgroundColor: 'rgba(255, 255, 255, 0)', 
            '&:hover': {
                color: 'rgba(235, 115, 27, 1)',
            },
            '&:focus': {
                backgroundColor: 'rgba(255, 255, 255, 0)', 
            },
            '&:active': {
                backgroundColor: 'rgba(255, 255, 255, 0)', 
            }
            }),
    };
    const DropdownIndicator = props => {
        return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                {
                props.selectProps.menuIsOpen ? 
                    
                    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="6.8451" cy="9.46229" r="1.53846" fill="#020203"/>
                        <circle cx="6.8451" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                        <circle cx="6.8451" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                        <path d="M0.691406 7.15385L7.03173 1L12.9991 7.15385" stroke="#020203"/>
                        <path d="M0.691406 7.15385L7.03173 1L12.9991 7.15385" stroke="black" strokeOpacity="0.2"/>
                        <path d="M0.691406 7.15385L7.03173 1L12.9991 7.15385" stroke="black" strokeOpacity="0.2"/>
                    </svg>
                    : 
                    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.30786 3.3584)" fill="#020203"/>
                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.30786 3.3584)" fill="black" fillOpacity="0.2"/>
                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.30786 3.3584)" fill="black" fillOpacity="0.2"/>
                        <path d="M0.692383 4.1274L7.03271 10.2812L13.0001 4.1274" stroke="#020203"/>
                        <path d="M0.692383 4.1274L7.03271 10.2812L13.0001 4.1274" stroke="black" strokeOpacity="0.2"/>
                        <path d="M0.692383 4.1274L7.03271 10.2812L13.0001 4.1274" stroke="black" strokeOpacity="0.2"/>
                    </svg>
                }
            </components.DropdownIndicator>
        )
        );
    };
    const formatDate = useCallback((dateString) => {
        return normalizeDateLike(dateString).display;
    }, []);
    // --- Merge target + features dates into one metadata list ---

    const buildMergedMetadata = useCallback((data = {}) => {
        const grouped = {};

        Object.entries(data || {}).forEach(([rawKey, rawPct]) => {
            const normalized = normalizeDateLike(rawKey);
            const pct = Number(rawPct) || 0;

            if (!normalized.key || pct <= 0) return;

            if (!grouped[normalized.key]) {
                grouped[normalized.key] = {
                    normalizedKey: normalized.key,
                    display: normalized.display,
                    pct: 0,
                    rawItems: [],
                };
            }

            grouped[normalized.key].pct += pct;
            grouped[normalized.key].rawItems.push({
                rawKey,
                pct,
            });
        });

        return Object.values(grouped)
            .sort((a, b) => a.normalizedKey.localeCompare(b.normalizedKey))
            .map((item) => ({
                value: item.rawItems[0]?.rawKey ?? item.normalizedKey, // оригінальний ключ
                rawValue: item.rawItems[0]?.rawKey ?? item.normalizedKey,
                normalizedKey: item.normalizedKey,
                key: item.normalizedKey,
                label: `${item.display} (${Number(item.pct.toFixed(2))} %)`,
                pct: Number(item.pct.toFixed(2)),
                rawItems: item.rawItems,
            }));
    }, []);

    const getDataObservation = useCallback(async (t, m) => {
        if (!t || !m) return;
        setObsLoading(true);
        try {
            const token = localStorage.getItem("token");
            localStorage.setItem("countactivetime", Date.now());

            const response = await fetch(
                `${Domen.url}model/dateDistribution?feature_dataset_id=${t}&target_dataset_id=${m}`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: token,
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (!response.ok) {
                console.error("Request failed:", response.status);
                return;
            }

            const data = await response.json();
            console.log(data);

            setMetadata(buildMergedMetadata(data));
        } catch (error) {
            console.error("getDataObservation error:", error);
        } finally {
            setObsLoading(false); 
        }
    }, [buildMergedMetadata]);

    
    const changecategorytarget = useCallback((val) => {
        const selectedDataset = (GlobalState.dataset || []).find((n) => n.id === val || String(n.id) === String(val));
        const nextOptions = Object.values(selectedDataset?.columnNames || {}).map((value) => ({
            value,
            label: value,
        }));

        setOptiontarget(val);
        setOptionfields(nextOptions);
        setOptiontargetfields("");
    }, []);

    const changecategorymetrix = useCallback((val) => {
        setOptionmetrics(val);
    }, []);

    useEffect(() => {
        if (optiontarget && optionmetrics) {
            getDataObservation(optiontarget, optionmetrics);
        }
    }, [getDataObservation, optiontarget, optionmetrics]);
    

    // --- Multiselect with checkboxes (react-select) ---
        const ObsOption = (props) => {
            const { isSelected, label } = props;
    
            return (
                <components.Option {...props}>
                <div className="himciObsMs__optRow">
                    {isSelected ? 
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="3" y="3" width="14" height="14" rx="2" fill="white"/>
                        <path d="M5.20833 2.5C4.49004 2.5 3.80116 2.78534 3.29325 3.29325C2.78534 3.80116 2.5 4.49004 2.5 5.20833V14.7917C2.5 15.51 2.78534 16.1988 3.29325 16.7067C3.80116 17.2147 4.49004 17.5 5.20833 17.5H14.7917C15.51 17.5 16.1988 17.2147 16.7067 16.7067C17.2147 16.1988 17.5 15.51 17.5 14.7917V5.20833C17.5 4.49004 17.2147 3.80116 16.7067 3.29325C16.1988 2.78534 15.51 2.5 14.7917 2.5H5.20833ZM3.75 5.20833C3.75 4.40333 4.40333 3.75 5.20833 3.75H14.7917C15.5967 3.75 16.25 4.40333 16.25 5.20833V14.7917C16.25 15.1784 16.0964 15.5494 15.8229 15.8229C15.5494 16.0964 15.1784 16.25 14.7917 16.25H5.20833C4.82156 16.25 4.45063 16.0964 4.17714 15.8229C3.90365 15.5494 3.75 15.1784 3.75 14.7917V5.20833ZM14.4 7.73333C14.4614 7.67611 14.5107 7.60711 14.5448 7.53045C14.579 7.45378 14.5973 7.37102 14.5988 7.2871C14.6003 7.20318 14.5849 7.11983 14.5534 7.042C14.522 6.96418 14.4752 6.89348 14.4159 6.83414C14.3565 6.77479 14.2858 6.728 14.208 6.69656C14.1302 6.66513 14.0468 6.64969 13.9629 6.65117C13.879 6.65265 13.7962 6.67102 13.7196 6.70518C13.6429 6.73934 13.5739 6.78859 13.5167 6.85L8.33083 12.03L6.48333 10.1833C6.36485 10.0729 6.20815 10.0128 6.04623 10.0157C5.88431 10.0185 5.72983 10.0841 5.61531 10.1986C5.5008 10.3132 5.43521 10.4676 5.43235 10.6296C5.4295 10.7915 5.4896 10.9482 5.6 11.0667L7.8875 13.355C8.00469 13.472 8.16354 13.5378 8.32917 13.5378C8.49479 13.5378 8.65365 13.472 8.77083 13.355L14.4 7.73333Z" fill="#34C759"/>
                    </svg>
                    : 
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="3.00195" y="3.00098" width="14" height="14" rx="2" fill="white"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.23875 3.33301H14.7626C15.2677 3.33301 15.7522 3.53369 16.1094 3.8909C16.4666 4.24811 16.6673 4.7326 16.6673 5.23777V14.7616C16.6673 15.2668 16.4666 15.7512 16.1094 16.1084C15.7522 16.4657 15.2677 16.6663 14.7626 16.6663H5.23875C4.73357 16.6663 4.24909 16.4657 3.89188 16.1084C3.53466 15.7512 3.33398 15.2668 3.33398 14.7616V5.23777C3.33398 4.7326 3.53466 4.24811 3.89188 3.8909C4.24909 3.53369 4.73357 3.33301 5.23875 3.33301Z" stroke="#C7C7CC" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    }
                    <span className="himciObsMs__optLabel">{label}</span>
                </div>
                </components.Option>
            );
        };
    
        const obsMultiStyles = {
            control: (provided, state) => ({
            ...provided,
            background: "rgba(255, 255, 255, 1)",
            width: "calc(100% - 20px)",
            minHeight: "27px",
           
            border: state.menuIsOpen
                ? "1px solid rgba(245, 197, 56, 1)"
                : "1px solid rgba(255, 255, 255, 1)",
            borderBottom: '0px',
            borderRadius: 8,
            boxShadow: "none",   // 🔥 прибрали синій outline
            outline: "none",
            borderBottomLeftRadius: state.menuIsOpen? 0: 8, borderBottomRightRadius: state.menuIsOpen? 0: 8,    
            cursor: "pointer",
            
            "&:hover": { border: state.menuIsOpen? "1px solid rgba(245, 197, 56, 1)": "1px solid rgb(255, 255, 255)", borderBottom: '0px', borderBottomLeftRadius: state.menuIsOpen? 0: 8, borderBottomRightRadius: state.menuIsOpen? 0: 8, },
            }),
            valueContainer: (provided) => ({
            ...provided,
            paddingLeft: 10,
            paddingRight: 10,
            paddingTop: 0,
            paddingBottom: 0,
            
            position: 'relative',
           
            }),
            menu: (provided) => ({
            ...provided,
            width: "calc(100% - 20px)",
            marginTop: 0,
            boxShadow: "none",
            border: "1px solid rgba(245, 197, 56, 1)",
            borderTop: 0,
            borderRadius: 8,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            }),
            menuList: (provided) => ({
            ...provided,
            // maxHeight: 175, // внутрішній скрол
            maxHeight: "none",
            overflow: "visible", 
            paddingTop: 0,
            paddingBottom: 6,
            maxWidth: 'calc(100% - 12px)'
            }),
            option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? "rgba(255, 255, 255, 1)" : "transparent", // зелене для вибраних
            color: "rgba(2, 2, 3, 0.6)",
            fontSize: '12px',
            padding: '4px 12px',
            cursor: "pointer",
            "&:hover": { backgroundColor: "rgba(245, 247, 251, 1)" },
            }),
            multiValue: (provided) => ({
            ...provided,
            backgroundColor: "rgba(244, 245, 247, 1)",
            borderRadius: 999,
            }),
            multiValueLabel: (provided) => ({
            ...provided,
            fontSize: 13,
            color: "rgba(2, 2, 3, 1)",
            }),
            multiValueRemove: (provided) => ({
            ...provided,
            cursor: "pointer",
            ":hover": { backgroundColor: "transparent", color: "rgba(2, 2, 3, 1)" },
            }),
        };
    
    const ObsMenuList = (props) => {
        const { options, selectProps } = props;
        const totalCount = options?.length ?? 0;

        const listRef = React.useRef(null);

        // 1) відновлюємо скрол ПІСЛЯ того, як react-select сам “посмикав” його
        React.useLayoutEffect(() => {
            const el = listRef.current;
            if (!el) return;

            // двічі: rAF + microtask, щоб точно бути "після" внутрішнього scrollToFocusedOption
            requestAnimationFrame(() => {
            el.scrollTop = OBS_MENU_SCROLL.top || 0;
            queueMicrotask(() => {
                el.scrollTop = OBS_MENU_SCROLL.top || 0;
            });
            });
        });

        // 2) постійно запам’ятовуємо позицію скрола
        const onScrollCapture = (e) => {
            OBS_MENU_SCROLL.top = e.currentTarget.scrollTop;
        };

        const onSelectAll = (e) => {
            e.preventDefault();
            e.stopPropagation();
            selectProps.onChange(options, { action: "select-option" });
        };

        const onReset = (e) => {
            e.preventDefault();
            e.stopPropagation();
            selectProps.onChange([], { action: "clear" });
        };

        return (
            <components.MenuList {...props}>
            {/* робимо ОЦЕ scroll-контейнером, а не покладаємось на внутрішній div react-select */}
            <div
                ref={listRef}
                onScrollCapture={onScrollCapture}
                className="himciObsMs__scroll"
                style={{
                maxHeight: 175,
                overflowY: "auto",
                paddingTop: 0,
                paddingBottom: 6,
                }}
            >
                <div
                className="himciObsMs__menuTop"
                onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
                >
                <button type="button" className="himciObsMs__menuBtn" onMouseDown={onSelectAll}>
                    Select all ({totalCount})
                </button>
                <span className="himciObsMs__menuSep">-</span>
                <button
                    type="button"
                    className="himciObsMs__menuBtn himciObsMs__menuBtn--muted"
                    onMouseDown={onReset}
                >
                    Reset
                </button>
                </div>

                {props.children}
            </div>
            </components.MenuList>
        );
    };


    const [textloading, setTextloading] = useState(langv?.add_model?.text18);
    const [textloadingcompleated, setTextloadingcompleated] = useState(langv?.add_model?.text19);
    const startmodel = () =>{
        
        createModel();
    }
    async function getModels()
    {
        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
        const response = await fetch(Domen.url + `model`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if (response.ok) {
            const data = await response.json();
         
            if(data&&data.items.length>0)
            {
                data.items?.map((n)=>
                {
                    addModels(n)
                })
                setLoad(2);
                setTimeout(function(){
                    setAddmodel(false);
                }, 2000)
                
            }
            
        }
        else
        {
            const user = Pool.getCurrentUser();
            user.getSession((err, session) => {
                if (err) {
                    console.error("Error fetching user session:", err);                       
                } 
                else 
                {
                    if (!session) {
                        console.log("No session found");
                        return;
                    }
                    else
                    {
                        const refreshToken  = session.getRefreshToken();
                        user.refreshSession(refreshToken, (err, result) => {
                            const { accessToken } = result;
                            localStorage.setItem("token", accessToken.jwtToken);
                            getModels();
                        });
                    }
                    
                }
            })
        }
    } 
    const addmodel = () =>{
        changepopupaddAttachmentAnalitics(0)
    }
    
    const adddatasetprewWorkspacecheck = async () => {

        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
        const response = await fetch(Domen.url + `dataset/`+GlobalState.activemodel?.lastTrain?.featureDataset+`/preview`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        
        if (response.ok) {
            const data = await response.json();
           
            changeActiveModeldatasetPrew(data.sample.slice(0, 3));
        } 
    }
    const retrain = async () =>{
        if(GlobalState.activemodel?.lastTrain?.deploymentState=='done'||GlobalState.activemodel?.lastTrain?.deploymentState=='in_progress')
        {

        }
        else
        {
            setDisablebut(false)
            setLoad(0);
        }
      
        
    }

    const createModel = async () =>{

        setLoad(1);
        const getUseGpu = () => {
            const username = Pool.getCurrentUser()?.username;
            return username === "admin";
        };
        var token = localStorage.getItem("token");
        const additionalTestingPeriod = observationSelected.reduce((acc, item) => {
            const rawKey = item?.rawValue ?? item?.value;
            if (!rawKey) return acc;

            acc[rawKey] = Number(item?.pct) || 0;
            return acc;
        }, {});
        var model = {
            featureDataset: optionmetrics,
            targetDataset: optiontarget,
            targetColumnName: optiontargetfields,
            learningType: optiontype,
            learningCyclesCount: countmodal,
            name: namemodal,
            additionalTestingPeriod:additionalTestingPeriod,
            useGpu: getUseGpu()
        };
        console.log(JSON.stringify(model)+"create");
        localStorage.setItem("countactivetime", Date.now());
        const response = await fetch(Domen.url + `model`, {
            method: 'POST',
            headers: {
                'Authorization': token,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(model),
        })
        if (response.status === 200) {
            const data = await response.json();

            // getModel(data.id)
            openmodel({ id: data.id, name: namemodal });
            return;
        }
        else
        {
            const errorText = await response.text();

            let errorMessage = errorText;

            try {
                const parsedError = JSON.parse(errorText);
                errorMessage = parsedError?.detail || errorText;
            } catch (e) {
                errorMessage = errorText || "Something went wrong";
            }

            console.error("Create model failed:", response.status, errorMessage);

            setTextloadingcompleated(errorMessage);
            setLoad(4);
        }

       
       
    }
    const setAddmodel0 = ()=>{
        window.location.href='/analytics'
    }
    const obsSelectComponents = useMemo(() => ({
        DropdownIndicator,
        Option: ObsOption,
        MenuList: ObsMenuList,
    }), []); // важливо: порожні deps
    return (
        
        <div className='addmodel_block'>
           
            <div className='addmodel_head'>
                    <div className='addmodel_head_tabs'>
                        <div className='addmodel_head_tab active'>
                            {
                                GlobalState.activemodel.modelName!=null?
                                <>{langv?.open_model?.text16}: {GlobalState.activemodel.modelName}</>
                                :
                                <>{langv?.open_model?.text17}</>
                            }
                            
                            
                        </div>  
                    </div>
                    <div className='controler_top'> 
                        <div className='betta'>
                            <div className='betta_inside'>
                            {langv?.beta?.head_text}
                            </div>
                        </div>
                        {
                            GlobalState.activemodel.modelName!=null?
                            <div className='buttons_line_v'>
                                <div className={GlobalState.activemodel?.lastTrain?.deploymentState=='done'||GlobalState.activemodel?.lastTrain?.deploymentState=='in_progress'?'button_retrain inactive':'button_retrain'} onClick={()=>retrain()}>
                                    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.6956 2.82349L15.8737 3.0029L16.0511 2.82291L16.7705 2.0932C16.7707 2.09299 16.7709 2.09278 16.7711 2.09257C17.3228 1.54261 18.2695 1.93632 18.2695 2.71488V6.75267C18.2695 7.2329 17.875 7.6274 17.3934 7.6274H13.3505C12.5746 7.6274 12.1845 6.68463 12.7389 6.131L14.4393 4.43265L14.6156 4.25657L14.4402 4.07969C13.1805 2.81 11.4513 2.00374 9.51033 2.00374H9.5101C8.45948 2.0047 7.42251 2.24154 6.47588 2.69677C5.52925 3.152 4.69717 3.81396 4.04121 4.63373C3.38524 5.45349 2.92218 6.41007 2.68629 7.43273C2.45052 8.45486 2.44774 9.51684 2.67812 10.5402C3.22815 13.1318 5.31754 15.2418 7.91224 15.8144C9.47803 16.1796 11.122 15.9953 12.5678 15.2924C14.0134 14.5897 15.1728 13.4113 15.851 11.9553C15.9857 11.6796 16.2863 11.5016 16.6163 11.5016C17.2635 11.5016 17.6863 12.1737 17.4043 12.7634L17.404 12.764C16.6955 14.2558 15.5777 15.5162 14.1804 16.3988C12.7831 17.2815 11.1637 17.75 9.51033 17.75C4.3316 17.75 0.225969 13.2785 0.828369 7.97309L0.828415 7.97268C1.27699 3.96246 4.58448 0.702395 8.60067 0.298004L8.6018 0.297885C9.89815 0.161421 11.2086 0.317531 12.4365 0.754679C13.6643 1.19183 14.7781 1.89884 15.6956 2.82349Z" fill="#020203"/>
                                        <path d="M15.6956 2.82349L15.8737 3.0029L16.0511 2.82291L16.7705 2.0932C16.7707 2.09299 16.7709 2.09278 16.7711 2.09257C17.3228 1.54261 18.2695 1.93632 18.2695 2.71488V6.75267C18.2695 7.2329 17.875 7.6274 17.3934 7.6274H13.3505C12.5746 7.6274 12.1845 6.68463 12.7389 6.131L14.4393 4.43265L14.6156 4.25657L14.4402 4.07969C13.1805 2.81 11.4513 2.00374 9.51033 2.00374H9.5101C8.45948 2.0047 7.42251 2.24154 6.47588 2.69677C5.52925 3.152 4.69717 3.81396 4.04121 4.63373C3.38524 5.45349 2.92218 6.41007 2.68629 7.43273C2.45052 8.45486 2.44774 9.51684 2.67812 10.5402C3.22815 13.1318 5.31754 15.2418 7.91224 15.8144C9.47803 16.1796 11.122 15.9953 12.5678 15.2924C14.0134 14.5897 15.1728 13.4113 15.851 11.9553C15.9857 11.6796 16.2863 11.5016 16.6163 11.5016C17.2635 11.5016 17.6863 12.1737 17.4043 12.7634L17.404 12.764C16.6955 14.2558 15.5777 15.5162 14.1804 16.3988C12.7831 17.2815 11.1637 17.75 9.51033 17.75C4.3316 17.75 0.225969 13.2785 0.828369 7.97309L0.828415 7.97268C1.27699 3.96246 4.58448 0.702395 8.60067 0.298004L8.6018 0.297885C9.89815 0.161421 11.2086 0.317531 12.4365 0.754679C13.6643 1.19183 14.7781 1.89884 15.6956 2.82349Z" fill="black" fillOpacity="0.2"/>
                                        <path d="M15.6956 2.82349L15.8737 3.0029L16.0511 2.82291L16.7705 2.0932C16.7707 2.09299 16.7709 2.09278 16.7711 2.09257C17.3228 1.54261 18.2695 1.93632 18.2695 2.71488V6.75267C18.2695 7.2329 17.875 7.6274 17.3934 7.6274H13.3505C12.5746 7.6274 12.1845 6.68463 12.7389 6.131L14.4393 4.43265L14.6156 4.25657L14.4402 4.07969C13.1805 2.81 11.4513 2.00374 9.51033 2.00374H9.5101C8.45948 2.0047 7.42251 2.24154 6.47588 2.69677C5.52925 3.152 4.69717 3.81396 4.04121 4.63373C3.38524 5.45349 2.92218 6.41007 2.68629 7.43273C2.45052 8.45486 2.44774 9.51684 2.67812 10.5402C3.22815 13.1318 5.31754 15.2418 7.91224 15.8144C9.47803 16.1796 11.122 15.9953 12.5678 15.2924C14.0134 14.5897 15.1728 13.4113 15.851 11.9553C15.9857 11.6796 16.2863 11.5016 16.6163 11.5016C17.2635 11.5016 17.6863 12.1737 17.4043 12.7634L17.404 12.764C16.6955 14.2558 15.5777 15.5162 14.1804 16.3988C12.7831 17.2815 11.1637 17.75 9.51033 17.75C4.3316 17.75 0.225969 13.2785 0.828369 7.97309L0.828415 7.97268C1.27699 3.96246 4.58448 0.702395 8.60067 0.298004L8.6018 0.297885C9.89815 0.161421 11.2086 0.317531 12.4365 0.754679C13.6643 1.19183 14.7781 1.89884 15.6956 2.82349Z" fill="black" fillOpacity="0.2"/>
                                        <path d="M15.6956 2.82349L15.8737 3.0029L16.0511 2.82291L16.7705 2.0932C16.7707 2.09299 16.7709 2.09278 16.7711 2.09257C17.3228 1.54261 18.2695 1.93632 18.2695 2.71488V6.75267C18.2695 7.2329 17.875 7.6274 17.3934 7.6274H13.3505C12.5746 7.6274 12.1845 6.68463 12.7389 6.131L14.4393 4.43265L14.6156 4.25657L14.4402 4.07969C13.1805 2.81 11.4513 2.00374 9.51033 2.00374H9.5101C8.45948 2.0047 7.42251 2.24154 6.47588 2.69677C5.52925 3.152 4.69717 3.81396 4.04121 4.63373C3.38524 5.45349 2.92218 6.41007 2.68629 7.43273C2.45052 8.45486 2.44774 9.51684 2.67812 10.5402C3.22815 13.1318 5.31754 15.2418 7.91224 15.8144C9.47803 16.1796 11.122 15.9953 12.5678 15.2924C14.0134 14.5897 15.1728 13.4113 15.851 11.9553C15.9857 11.6796 16.2863 11.5016 16.6163 11.5016C17.2635 11.5016 17.6863 12.1737 17.4043 12.7634L17.404 12.764C16.6955 14.2558 15.5777 15.5162 14.1804 16.3988C12.7831 17.2815 11.1637 17.75 9.51033 17.75C4.3316 17.75 0.225969 13.2785 0.828369 7.97309L0.828415 7.97268C1.27699 3.96246 4.58448 0.702395 8.60067 0.298004L8.6018 0.297885C9.89815 0.161421 11.2086 0.317531 12.4365 0.754679C13.6643 1.19183 14.7781 1.89884 15.6956 2.82349Z" stroke="white" stroke-width="0.5"/>
                                    </svg>
                                    {langv?.open_model?.text14}
                                </div>
                                
                                <div className={GlobalState.activemodel?.lastTrain?.deploymentState=='done'||GlobalState.activemodel?.lastTrain?.deploymentState=='in_progress'?'button_retrain inactive':'button_retrain'} onClick={()=>addmodel()}> 
                                    <svg width="21" height="27" viewBox="0 0 21 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.5 24L17 13.5H10.5V3L4 13.5H10.5V24Z" stroke="#1C1E20" strokeOpacity="0.6" stroke-width="1.5"/>
                                    </svg>
                                    {langv?.open_model?.text15}
                                </div>
                            </div>
                            :
                            <></>
                        }
                        
                        <div className='addmodel_head_back addmod' onClick={()=>setAddmodel0(false)}>
                        
                            
                            <svg className='def_icon' width="34" height="32" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M32.4226 15C32.7799 15.6188 32.7799 16.3812 32.4226 17L25.5773 28.8564C25.2201 29.4752 24.5598 29.8564 23.8453 29.8564L10.1547 29.8564C9.44017 29.8564 8.77991 29.4752 8.42265 28.8564L1.57735 17C1.22008 16.3812 1.22008 15.6188 1.57735 15L8.42265 3.14359C8.77991 2.52479 9.44017 2.14359 10.1547 2.14359L23.8453 2.14359C24.5598 2.14359 25.2201 2.52479 25.5774 3.14359L32.4226 15Z" fill="#F5C538" stroke="#F5C538"/>
                                <path d="M21.9492 11.0488L12.0497 20.9483" stroke="#020203" strokeLinecap="round"/>
                                <path d="M21.9492 11.0488L12.0497 20.9483" stroke="black" strokeOpacity="0.2" strokeLinecap="round"/>
                                <path d="M21.9492 11.0488L12.0497 20.9483" stroke="black" strokeOpacity="0.2" strokeLinecap="round"/>
                                <path d="M12.0508 11.0488L21.9503 20.9483" stroke="#020203" strokeLinecap="round"/>
                                <path d="M12.0508 11.0488L21.9503 20.9483" stroke="black" strokeOpacity="0.2" strokeLinecap="round"/>
                                <path d="M12.0508 11.0488L21.9503 20.9483" stroke="black" strokeOpacity="0.2" strokeLinecap="round"/>
                            </svg>
                            <svg className='hov_icon' width="34" height="32" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M32.4226 15C32.7799 15.6188 32.7799 16.3812 32.4226 17L25.5773 28.8564C25.2201 29.4752 24.5598 29.8564 23.8453 29.8564L10.1547 29.8564C9.44017 29.8564 8.77991 29.4752 8.42265 28.8564L1.57735 17C1.22008 16.3812 1.22008 15.6188 1.57735 15L8.42265 3.14359C8.77991 2.52479 9.44017 2.14359 10.1547 2.14359L23.8453 2.14359C24.5598 2.14359 25.2201 2.52479 25.5774 3.14359L32.4226 15Z" fill="#41A8B1" stroke="#41A8B1"/>
                                <path d="M21.9492 11.0488L12.0497 20.9483" stroke="#020203" strokeLinecap="round"/>
                                <path d="M21.9492 11.0488L12.0497 20.9483" stroke="black" strokeOpacity="0.2" strokeLinecap="round"/>
                                <path d="M21.9492 11.0488L12.0497 20.9483" stroke="black" strokeOpacity="0.2" strokeLinecap="round"/>
                                <path d="M12.0508 11.0488L21.9503 20.9483" stroke="#020203" strokeLinecap="round"/>
                                <path d="M12.0508 11.0488L21.9503 20.9483" stroke="black" strokeOpacity="0.2" strokeLinecap="round"/>
                                <path d="M12.0508 11.0488L21.9503 20.9483" stroke="black" strokeOpacity="0.2" strokeLinecap="round"/>
                            </svg>

                        </div>
                    
                    </div>
            </div>
             
            <div className='addmodel_body'>
                    <div className='addmodel_fields obs-wrapper'>
                        <div className='addmodel_fields_line'>
                            <div className='addmodel_fields_line_title'>{langv?.open_model?.text18}</div>
                            <div className='icon_disable' onClick={()=>setDisabletitle(!disabletitle)}>
                                {
                                    !disabletitle?
                                
                                    <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g opacity="0.4">
                                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="#020203"/>
                                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                        <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="#020203"/>
                                        <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                        <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                        </g>
                                    </svg>
                                    
                                    :
                                    
                                    <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g opacity="0.4">
                                        <circle cx="7.1537" cy="9.46229" r="1.53846" fill="#020203"/>
                                        <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                        <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                        <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="#020203"/>
                                        <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                        <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                        </g>
                                    </svg>
                                    
                                }
                                

                                
                            </div>
                        </div>
                        {obsLoading && <div className="obs-blur-overlay"><Loading text = {"Loading ..."}/></div>}
                        {

                            disabletitle?
                            <></>
                            :
                            <>
                            <div className='addmodel_fields_line' style={{marginTop: "24px", position: "relative", zIndex: "99999999"}}>
                                <div className='addmodel_fields_col'>
                                    <label>{langv?.add_model?.text4}</label>
                                    <input
                                        id="source"
                                        type="text"
                                        placeholder={langv?.add_model?.text5}
                                        className=""
                                        value={namemodal}
                                        onChange={(event) =>setNamemodal(event.target.value)}
                                    />
                                </div>
                                <div className='addmodel_fields_col'>
                                    <label>{langv?.add_model?.text20}</label>
                                    {/* <input
                                        id="source"
                                        type="text"
                                        placeholder={langv?.add_model?.text6}
                                        className=""
                                        value={countmodal}
                                        onChange={(event) => Countamoda(event.target.value)}
                                    /> */}
                                    <Select 
                                        components={{ DropdownIndicator }}
                                        options={optionsstep} 
                                        styles={customStyles} 
                                        classNamePrefix='filter'
                                        className='selectproduct'
                                          
                                        placeholder={<div className='selectplace active'>{countmodal||langv?.open_model?.text9}</div>}
                                        onChange={(option) => Countamoda(option.value)}
                                    />
                                </div>
                                <div className='addmodel_fields_col' style={{position: "relative", zIndex: "999999999999999"}}>
                                    <label>{langv?.add_model?.text7}</label>
                                    <Select 
                                        components={{ DropdownIndicator }}
                                        options={optionstype} 
                                        styles={customStyles} 
                                        classNamePrefix='filter'
                                        className='selectproduct'
                                        
                                        placeholder={<div className='selectplace active'>{langv?.add_model?.text8}</div>}
                                        onChange={(option) => setOptiontype(option.value)}
                                    />
                                </div>
                            </div>
                            <div className='addmodel_fields_line' style={{marginTop: "20px", position: "relative", zIndex: "999999"}}>
                                <div className='addmodel_fields_col'>
                                    <label>{langv?.add_model?.text9}</label>
                                    <Select 
                                        components={{ DropdownIndicator }}
                                        options={options} 
                                        styles={customStyles} 
                                        classNamePrefix='filter'
                                        className='selectproduct'
                                          
                                        placeholder={<div className='selectplace active'>{langv?.add_model?.text10}</div>}
                                        onChange={(option) => changecategorymetrix(option.value)}
                                    />
                                </div>
                                <div className='addmodel_fields_col'>
                                    <label>{langv?.add_model?.text11}</label>
                                    <Select 
                                        components={{ DropdownIndicator }}
                                        options={options} 
                                        styles={customStyles} 
                                        classNamePrefix='filter'
                                        className='selectproduct'
                                          
                                        placeholder={<div className='selectplace active'>{langv?.add_model?.text12}</div>}
                                        onChange={(option) => changecategorytarget(option.value)}
                                    />
                                </div>
                                <div className='addmodel_fields_col'>
                                    <label>{langv?.add_model?.text13}</label>
                                    <Select 
                                        components={{ DropdownIndicator }}
                                        options={optionfields} 
                                        styles={customStyles} 
                                        classNamePrefix='filter'
                                        className='selectproduct'
                                        value={
                                            optionfields.find((option) => option.value === optiontargetfields) || null
                                        }  
                                        placeholder={<div className='selectplace active'>{langv?.add_model?.text14}</div>}
                                        onChange={(option) => setOptiontargetfields(option.value)}
                                    />
                                </div>
                            </div>
                            <div className='addmodel_fields_line align_items_fe' style={{marginTop: "20px", minHeight: '75px',}}>
                                <div className='addmodel_fields_col'>
                                    <div className='addition'>
                                        Additional testing period
                                        <div className='click_tooltipe'>
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7 0C5.61553 0 4.26216 0.410543 3.11101 1.17971C1.95987 1.94888 1.06266 3.04213 0.532846 4.32122C0.003033 5.6003 -0.13559 7.00776 0.134506 8.36563C0.404603 9.7235 1.07129 10.9708 2.05026 11.9497C3.02922 12.9287 4.2765 13.5954 5.63437 13.8655C6.99224 14.1356 8.3997 13.997 9.67879 13.4672C10.9579 12.9373 12.0511 12.0401 12.8203 10.889C13.5895 9.73785 14 8.38447 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0ZM7 12.8333C5.84628 12.8333 4.71846 12.4912 3.75918 11.8502C2.79989 11.2093 2.05222 10.2982 1.61071 9.23232C1.16919 8.16642 1.05368 6.99353 1.27876 5.86197C1.50384 4.73042 2.05941 3.69102 2.87521 2.87521C3.69102 2.0594 4.73042 1.50383 5.86198 1.27875C6.99353 1.05367 8.16642 1.16919 9.23232 1.6107C10.2982 2.05221 11.2093 2.79989 11.8502 3.75917C12.4912 4.71846 12.8333 5.84627 12.8333 7C12.8333 8.54709 12.2188 10.0308 11.1248 11.1248C10.0308 12.2187 8.5471 12.8333 7 12.8333Z" fill="#8E8E93"/>
                                                <path d="M6.99832 5.65761C6.84361 5.65761 6.69524 5.71907 6.58585 5.82847C6.47645 5.93786 6.41499 6.08624 6.41499 6.24095V10.2076C6.41499 10.3623 6.47645 10.5107 6.58585 10.6201C6.69524 10.7295 6.84361 10.7909 6.99832 10.7909C7.15303 10.7909 7.30141 10.7295 7.4108 10.6201C7.5202 10.5107 7.58166 10.3623 7.58166 10.2076V6.24095C7.58166 6.08624 7.5202 5.93786 7.4108 5.82847C7.30141 5.71907 7.15303 5.65761 6.99832 5.65761ZM6.99832 3.26595C6.84041 3.27188 6.69076 3.33806 6.5801 3.45088C6.46945 3.5637 6.40619 3.71461 6.40332 3.87261V3.96595C6.40305 4.04206 6.41862 4.11739 6.44905 4.18715C6.47947 4.25691 6.52409 4.31958 6.58006 4.37116C6.63603 4.42274 6.70212 4.4621 6.77413 4.48674C6.84614 4.51138 6.92249 4.52076 6.99832 4.51428C7.15119 4.50851 7.29623 4.44519 7.4044 4.33702C7.51257 4.22885 7.57588 4.08381 7.58166 3.93095V3.79095C7.58212 3.71681 7.56687 3.64341 7.53691 3.57559C7.50696 3.50777 7.46298 3.44706 7.40787 3.39747C7.35277 3.34787 7.28778 3.31051 7.21719 3.28784C7.1466 3.26517 7.07201 3.25771 6.99832 3.26595Z" fill="#8E8E93"/>
                                            </svg>
                                            <div className='tooltipe'>
                                                By default, 80% of the records are used for training and 20% for testing the model. The additional testing period will also not be included in training.
                                            </div>
                                        </div>
                                        <label className="switch">
                                            <input type="checkbox" checked={isAdditionalTesting} onChange={(e) => setIsAdditionalTesting(e.target.checked)}/>
                                            <span className="slider_sw"></span>
                                        </label>
                                    </div>
                                </div>
                                {
                                    isAdditionalTesting?
                                
                                    <div className='addmodel_fields_col addmodel_fields_col_2'>
                                        <label style={{ marginTop: "6px" }}>Total: {Number(observationTotal).toFixed(2)}%</label>
                                        <Select
                                            components={obsSelectComponents}
                                            isMulti
                                            // menuIsOpen={true}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            options={metadata}
                                            value={observationSelected}
                                            onMenuOpen={() => setObsMenuOpen(true)}
                                            onMenuClose={() => setObsMenuOpen(false)}
                                            onChange={(vals) => {
                                                const next = vals || [];
                                                const total = next.reduce((sum, o) => sum + (o?.pct || 0), 0);
                                                setObservationSelected(next);
                                                setObservationError(total > 30);
                                            }}
                                            styles={obsMultiStyles}
                                            classNamePrefix="himciObsMs"
                                            menuShouldScrollIntoView={false}
                                            // className={disablebut ? "selectproduct tra1" : "selectproduct tra2"}
                                             
                                            isDisabled={false}
                                            className={"selectproduct tra2"}
                                            captureMenuScroll={false}
                                            menuListElRef={menuListElRef}
                                            menuScrollTopRef={menuScrollTopRef}
                                            blurInputOnSelect={false}
                                            placeholder={<div className="selectplace active">Select observation date</div>}
                                        />

                                    

                                    
                                        {observationError && (
                                            <div style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "6px" }}>
                                                The total selection of dates for additional testing period must not exceed 30%.
                                            </div>
                                        )}
                                    </div>
                                    :
                                    <div className='addmodel_fields_col addmodel_fields_col_2' style={{minHeight:"70px"}}></div>
                                }
                            
                            </div>
                            <div className='addmodel_fields_line' style={{marginBottom:"0px", marginTop: "20px"}}>
                                
                                    {
                                        load==0?
                                        <>
                                            <div className='addmodel_fields_col'></div>
                                            <div className='addmodel_fields_col'>
                                                <div className='addmodel_button_line' >
                                                    {
                                                        optionmetrics!=""&&optiontarget!=""&&optiontargetfields!=""&&optiontype!=""&&countmodal!=""&&namemodal!=""&&(isAdditionalTesting&&observationSelected.length>0||!isAdditionalTesting)&&!isObservationOverLimit?
                                                        <div className='addmodel_but' onClick={()=>startmodel()}>
                                                            {langv?.open_model?.text17}
                                                        </div>
                                                        :
                                                        <div className='addmodel_but inactive'>
                                                            {langv?.open_model?.text17}
                                                        </div>

                                                        
                                                    }
                                                    
                                                </div>
                                            </div>
                                            <div className='addmodel_fields_col'></div>
                                        </>
                                        :
                                    
                                        <div className='line_detailedeploy'>
                                            
                                            {
                                                GlobalState.activemodel?.lastTrain?.inputDatasetName||GlobalState.activemodel?.lastTrain?.outputDatasetName!=null?
                                                <>
                                                    <label>{langv?.open_model?.text19}</label>
                                                    <div className='detailedeploy'>
                                                        
                                                        {
                                                            GlobalState.activemodel?.lastTrain?.deploymentSchedule!=null?
                                                            <>{langv?.open_model?.text20}: {GlobalState.activemodel?.lastTrain?.deploymentSchedule}<br/></>
                                                            :
                                                            <></>
                                                        }
                                                        {
                                                            GlobalState.activemodel?.lastTrain?.deploymentSchedule!=null?
                                                            <>{langv?.open_model?.text21}: {GlobalState.activemodel?.lastTrain?.deploymentSchedule}<br/></>
                                                            :
                                                            <></>
                                                        }
                                                        {
                                                            GlobalState.activemodel?.lastTrain?.deploymentSchedule!=null?
                                                            <>{langv?.open_model?.text22} {GlobalState.activemodel?.lastTrain?.deploymentSchedule.split('T')[0]+" "+GlobalState.activemodel?.lastTrain?.deploymentSchedule.split('T')[1].split(".")[0]} {GlobalState.activemodel?.lastTrain?.deploymentPeriodicity}</>
                                                            :
                                                            <></>
                                                        }
                                                    </div>
                                                </>
                                                :
                                                <></>
                                            }
                                            
                                        </div> 
                                    }
                                
                            </div>
                            </>
                        }
                        {
                            load==4?
                            <LoadingFail text = {textloadingcompleated}/>
                            :
                            <></>
                        }
                    </div>
            </div>
           
        </div>
    );
})

export default Addmodels;
